"use client";

import type { ReactNode } from "react";
import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { useAuth } from "@/hooks/use-auth";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { authStepHref, preserveAuthReturnTarget } from "@/lib/auth-session";
import { buildReturnToPath } from "@/lib/auth-intent";

const PASSWORD_CHANGE_PATH = "/change-password";

/** Prevents protected UI from rendering while the server requires a password change. */
export function FirstLoginGate({ children }: { children: ReactNode }): ReactNode {
  const pathname = usePathname();
  const router = useRouter();
  const { isAuthenticated, isLoading, user, context } = useAuth();
  const passwordChangeRequired =
    isAuthenticated && user?.mustChangePassword === true;

  useEffect(() => {
    if (
      !isLoading &&
      passwordChangeRequired &&
      pathname !== PASSWORD_CHANGE_PATH
    ) {
      const target = preserveAuthReturnTarget(buildReturnToPath(), context?.mode ?? null);
      router.replace(authStepHref(PASSWORD_CHANGE_PATH, target));
    }
  }, [isLoading, passwordChangeRequired, pathname, router, context?.mode]);

  if (passwordChangeRequired && pathname !== PASSWORD_CHANGE_PATH) {
    return <LoadingSpinner fullScreen label="Připravuji bezpečnou změnu hesla…" />;
  }

  return children;
}
